import { blueGray300, white } from "../theme/colors";
export default (function (theme) {
  return {
    uncheckedDefaultBg: {
      backgroundColor: white
    },
    icon: {
      fill: blueGray300
    },
    checked: {
      '& #checkboxCheckV': {
        transformOrigin: 'center left',
        animation: '$grow 225ms'
      },
      fill: theme.palette.primary["default"]
    },
    '@keyframes grow': {
      from: {
        transform: 'scale(.3)'
      },
      to: {
        transform: 'scale(1)'
      }
    }
  };
});